/*
  PURAVA · clone Herbies (APERÇU, thème non publié). Source : PDP-HERBIES-2026-10-11/prototype/_outils/purava-herbies.src.js
  Tout est scopé à #phx. Repris du prototype : galerie, paliers, accordéons, carrousels, frise, barre collante, compte à rebours.
  AJOUT AU PANIER (branchement minimal) :
    - fetch natif POST /cart/add.js du variant payant (data-variant-id), quantité = palier (1, 2 ou 3 payants) ;
      fetch natif et bouton type="button" comme sur la v2 (mémoire kaching-atc-native-fetch) ;
    - puis ouverture du tiroir du thème (<cart-drawer>, panier B) : _onCartRefresh + cart:refresh + show(), comme v2-buy-page.js.
  NON BRANCHÉ : les pouches offerts, la réduction BOGO et les cadeaux viennent de Kaching (bloc absent de ce modèle).
  Sur cet aperçu, le panier ne contient donc que les pouches payants.
  SUIVI : aucun fbq (le pixel vient de content_for_header) ; seul un Shopify.analytics.publish best-effort après un ajout confirmé.
*/
(() => {
  const R = document.getElementById('phx');
  if (!R || R.dataset.ready) return;
  R.dataset.ready = '1';
  const $ = (s, r = R) => r.querySelector(s), $$ = (s, r = R) => [...r.querySelectorAll(s)];
  const VID = R.dataset.variantId;
  const tierBtn = t => $(`.tier[data-tier="${t}"]`);
  const T = t => { const b = tierBtn(t); return { qty: +b.dataset.qty, label: b.querySelector('.tier__t').textContent.trim(), price: b.dataset.price, compare: b.dataset.compare }; };
  let tier = 2;

  /* ---- Bandeaux défilants ---- */
  function fillLoop(track, unitSel, pxPerSec) {
    if (!track) return;
    const units = [...track.querySelectorAll(unitSel)];
    if (!units.length) return;
    const unitW = units.reduce((a, u) => a + u.getBoundingClientRect().width, 0) + (parseFloat(getComputedStyle(track).columnGap) || 0) * units.length;
    const reps = Math.max(1, Math.ceil((innerWidth + 40) / Math.max(unitW, 1)));
    const frag = document.createDocumentFragment();
    for (let r = 1; r < reps * 2; r++) units.forEach(u => { const c = u.cloneNode(true); c.setAttribute('aria-hidden', 'true'); if (c.tagName === 'IMG') c.alt = ''; frag.appendChild(c); });
    track.appendChild(frag);
    track.style.animationDuration = (reps * unitW / pxPerSec).toFixed(1) + 's';
  }
  fillLoop($('.mq__track'), '.mq__it', 45);
  fillLoop($('#phx-ugcTrack'), 'img', 28);

  /* ---- Paliers ---- */
  function selectTier(t) {
    tier = t;
    $$('.tier').forEach(b => { const on = +b.dataset.tier === t; b.classList.toggle('is-sel', on); b.setAttribute('aria-checked', on); });
    $$('.gift').forEach(g => { const on = +g.dataset.gift <= t; g.classList.toggle('is-on', on); g.classList.toggle('is-off', !on); });
    $('#phx-giftN').textContent = t;
    const x = T(t);
    $('#phx-stkT').textContent = 'PURAVA · ' + x.label;
    $('#phx-stkP').textContent = x.price;
    $('#phx-stkC').textContent = x.compare;
    $$('.js-atc').forEach(b => b.setAttribute('aria-label', 'Add ' + x.label + ' to cart, ' + x.price + ' instead of ' + x.compare));
  }
  $$('.tier').forEach(b => b.addEventListener('click', () => selectTier(+b.dataset.tier)));
  $('.tiers').addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
    e.preventDefault();
    const n = ((tier - 1 + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : 2)) % 3) + 1;
    selectTier(n); tierBtn(n).focus();
  });

  /* ---- Galerie ---- */
  const track = $('#phx-galTrack'), thumbs = $$('.thumb'), row = $('#phx-thumbRow');
  let gi = 0;
  function setThumb(i) {
    gi = i;
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    const t = thumbs[i];
    row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2 });
  }
  /* Miniatures réactives (Arthur, 2026-10-12) : miniature active tout de suite, saut direct si on va loin,
     glissé doux seulement pour l'image voisine ; pendant un saut, le suivi du défilement ne contredit pas le choix. */
  let lockUntil = 0;
  function goGal(i) {
    i = (i + thumbs.length) % thumbs.length;
    const far = Math.abs(i - gi) > 1;
    lockUntil = Date.now() + (far ? 120 : 450);
    setThumb(i);
    track.scrollTo({ left: i * track.clientWidth, behavior: far ? 'auto' : 'smooth' });
  }
  thumbs.forEach((t, i) => t.addEventListener('pointerdown', e => { if (e.button === 0) goGal(i); }));
  thumbs.forEach((t, i) => t.addEventListener('click', e => { if (e.detail === 0) goGal(i); }));
  $('#phx-galPrev').addEventListener('click', () => goGal(gi - 1));
  $('#phx-galNext').addEventListener('click', () => goGal(gi + 1));
  track.addEventListener('scroll', () => {
    if (Date.now() < lockUntil) return;
    const i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== gi && i >= 0 && i < thumbs.length) setThumb(i);
  }, { passive: true });
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') goGal(gi + 1); if (e.key === 'ArrowLeft') goGal(gi - 1); });

  /* ---- Accordéons ---- */
  $$('.acc__q').forEach(q => q.addEventListener('click', () => {
    const it = q.parentElement, a = q.nextElementSibling, open = it.classList.contains('is-open');
    a.style.height = a.scrollHeight + 'px';
    if (open) { a.offsetHeight; a.style.height = '0px'; it.classList.remove('is-open'); }
    else { it.classList.add('is-open'); a.addEventListener('transitionend', () => { if (it.classList.contains('is-open')) a.style.height = 'auto'; }, { once: true }); }
    q.setAttribute('aria-expanded', !open);
  }));
  const sb = $('#phx-safetyBtn');
  sb.addEventListener('click', () => { const o = sb.getAttribute('aria-expanded') === 'true'; sb.setAttribute('aria-expanded', !o); $('#phx-safetyTxt').hidden = o; });

  /* ---- Carrousels (avis, raisons) ---- */
  function carousel(trackEl, prev, next, dotsEl, dimClass) {
    const cards = [...trackEl.children];
    dotsEl.innerHTML = cards.map(() => '<i></i>').join('');
    const dots = [...dotsEl.children];
    const current = () => {
      const c = trackEl.scrollLeft + trackEl.clientWidth / 2;
      let best = 0, d = Infinity;
      cards.forEach((el, i) => { const m = el.offsetLeft + el.offsetWidth / 2; if (Math.abs(m - c) < d) { d = Math.abs(m - c); best = i; } });
      return best;
    };
    const paint = () => { const i = current(); dots.forEach((x, k) => x.classList.toggle('on', k === i)); if (dimClass) cards.forEach((x, k) => x.classList.toggle(dimClass, k !== i)); };
    const go = dir => { const step = cards[0].offsetWidth + parseFloat(getComputedStyle(trackEl).columnGap || 10); trackEl.scrollBy({ left: dir * step, behavior: 'smooth' }); };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    let tt; trackEl.addEventListener('scroll', () => { clearTimeout(tt); tt = setTimeout(paint, 50); }, { passive: true });
    addEventListener('resize', paint);
    paint();
  }
  const mqD = matchMedia('(min-width:990px)');
  carousel($('#phx-revTrack'), $('#phx-revPrev'), $('#phx-revNext'), $('#phx-revDots'), mqD.matches ? null : 'is-dim');
  carousel($('#phx-whyTrack'), $('#phx-whyPrev'), $('#phx-whyNext'), $('#phx-whyDots'));
  const whyBtns = $$('#phx-whyList button'), whyCards = $$('#phx-whyTrack .wcard');
  const setWhy = i => { whyBtns.forEach((b, k) => b.classList.toggle('on', k === i)); whyCards.forEach((c, k) => c.classList.toggle('on', k === i)); };
  whyBtns.forEach((b, i) => { b.addEventListener('mouseenter', () => setWhy(i)); b.addEventListener('click', () => setWhy(i)); b.addEventListener('focus', () => setWhy(i)); });

  /* ---- Frise ---- */
  const tl = $('#phx-tlList'), tlItems = $$('#phx-tlList li');
  function paintTl() {
    const r = tl.getBoundingClientRect(), mid = innerHeight * 0.6;
    const p = Math.max(0, Math.min(1, (mid - r.top) / r.height));
    tl.style.setProperty('--p', p.toFixed(3));
    tlItems.forEach(li => li.classList.toggle('on', li.getBoundingClientRect().top + 8 < mid));
  }

  /* ---- Barre collante : visible entre le bouton principal et la fin de la page clone (avant le pied du thème) ---- */
  const stk = $('#phx-stk'), main = $('#phx-mainAtc');
  function paintStk() {
    const show = main.getBoundingClientRect().bottom < 0 && R.getBoundingClientRect().bottom > innerHeight;
    stk.classList.toggle('is-on', show);
    stk.setAttribute('aria-hidden', !show);
    $$('.js-atc', stk).forEach(b => b.tabIndex = show ? 0 : -1);
  }
  let raf = 0;
  addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; paintTl(); paintStk(); }); }, { passive: true });
  addEventListener('resize', () => { paintTl(); paintStk(); });
  paintTl(); paintStk();

  /* ---- Compte à rebours du prix du bundle : jusqu'à minuit, heure locale, chaque jour (comme l'ancienne page) ---- */
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    const now = new Date(), end = new Date(now);
    end.setHours(24, 0, 0, 0);
    const s = Math.max(0, Math.floor((end - now) / 1000));
    const v = [[Math.floor(s / 3600), 'HRS'], [Math.floor(s % 3600 / 60), 'MIN'], [s % 60, 'SEC']];
    v.forEach(([n, l], k) => { $('#phx-cd' + (k + 1)).textContent = pad(n); $('#phx-cl' + (k + 1)).textContent = l; });
  }
  tick(); setInterval(tick, 1000);

  /* ---- Ajout au panier : variant payant x palier, puis tiroir du thème ---- */
  function trackAdd(li) {
    try {
      const A = window.Shopify && window.Shopify.analytics;
      if (A && typeof A.publish === 'function') A.publish('product_added_to_cart', { cartLine: { quantity: (li && li.quantity) || T(tier).qty, merchandise: { id: 'gid://shopify/ProductVariant/' + VID } } });
    } catch (e) {}
  }
  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { location.href = '/cart'; return; }
    try { if (typeof drawer._onCartRefresh === 'function') drawer._onCartRefresh(); } catch (e) {}
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(() => {
      try { drawer.show(); document.body.style.overflow = 'hidden'; document.documentElement.style.overflow = 'hidden'; }
      catch (e) { location.href = '/cart'; }
    }, 300);
  }
  document.addEventListener('dialog:after-hide', e => {
    if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'cart-drawer') { document.body.style.overflow = ''; document.documentElement.style.overflow = ''; }
  });
  /* Ajout au panier par le pont Kaching (2026-10-11) : on attend que Kaching ait rendu ses barres (20 s max),
     on coche la barre du palier choisi, puis on clique le bouton caché .phx-kbtn ; v2-buy-page.js fait l'ajout
     (pouch offert fusionné par Kaching, reprises, suivi Meta + Shopify) et ouvre le tiroir, puis émet pv:atc:done.
     Si Kaching ne charge pas du tout, repli : ajout direct des pouches payants du palier. */
  const kbars = () => [...document.querySelectorAll('.phx-kbridge .kaching-bundles__bar')];
  function waitKaching(maxMs) {
    return new Promise(res => {
      const t0 = Date.now();
      (function tk() {
        if (kbars().length >= 3 && window.OpusNoATC === true) return res(true);
        if (Date.now() - t0 >= maxMs) return res(false);
        setTimeout(tk, 120);
      })();
    });
  }
  function selectKachingBar(t) {
    const bar = kbars()[t - 1];
    if (!bar || bar.classList.contains('kaching-bundles__bar--selected')) return;
    (bar.querySelector('input') || bar).click();
  }
  function setLoading(on) { $$('.js-atc').forEach(x => x.classList.toggle('is-loading', on)); }
  document.addEventListener('pv:atc:done', () => setLoading(false));
  function directAdd() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: VID, quantity: T(tier).qty })
    })
      .then(r => r.json().then(j => ({ ok: r.ok, body: j })))
      .then(res => { if (!res.ok) throw new Error((res.body && res.body.description) || 'add failed'); trackAdd(res.body); openDrawer(); })
      .catch(() => alert("Sorry, we couldn't add that to your cart. Please try again."))
      .finally(() => setLoading(false));
  }
  /* Seul le bouton principal (à côté des paliers) ajoute au panier. Les autres boutons « Add to cart » de la page
     (sections, barre collante) remontent au sélecteur de palier pour que la cliente choisisse (Arthur, 2026-10-12). */
  function goToTiers() {
    const t = $('.tiers') || $('.tier');
    if (!t) return;
    const y = t.getBoundingClientRect().top + scrollY - Math.max(90, innerHeight * .18);
    scrollTo({ top: y, behavior: 'smooth' });
    const box = t.closest('.tiers') || t;
    box.classList.remove('phx-flash'); void box.offsetWidth; box.classList.add('phx-flash');
  }
  $$('.js-atc').forEach(b => b.addEventListener('click', () => {
    if (b.id !== 'phx-mainAtc') { goToTiers(); return; }
    if (b.classList.contains('is-loading') || !VID) return;
    setLoading(true);
    waitKaching(20000).then(ok => {
      const kb = document.querySelector('.phx-kbridge .phx-kbtn');
      if (!ok || !kb) return directAdd();
      selectKachingBar(tier);
      setTimeout(() => { selectKachingBar(tier); kb.click(); }, 150);
    });
  }));

  /* Palier choisi sur l'accueil (?tier=1|2|3), sinon Buy 2 Get 2 par défaut */
  const qt = +(new URLSearchParams(location.search).get('tier') || 0);
  selectTier(qt >= 1 && qt <= 3 ? qt : 2);
  window.PURAVA_HERBIES = { selectTier };
})();
